export { default as payTypeListClassify } from "./payType";
import { ENV_URL as DEV_ENV_URL } from './dev';

const NODE_ENV = process.env.NODE_ENV === 'production';

export const cdnLink = '//sdk-static.zhangyuqu.com/Lianyun/SdkImg';

export const FLOAT_URL = `${window.location.origin}/h5sdk/floatWindow`

// 云挂机中台接口域名
export const getCloudApi = () => {
  if (!NODE_ENV) {
    return "//{*云挂机预发环境域名*}"
  }
  switch (window.location.hostname) {
    case "{*sdk预发环境域名*}":
      return "//{*云挂机预发环境域名*}";
    case "{*sdk测试环境域名*}":
      return "//{*云挂机测试环境域名*}";
    default:
      return "//{*云挂机线上环境域名*}"; 
  }
}

// 云挂机中台接口域名
export const getBoxApi = () => {
  if (!NODE_ENV) {
    return "{*云挂机测试环境域名*}"
  }
  switch (window.location.hostname) {
    case "{*sdk预发环境域名*}":
      return "{*云挂机预发环境域名*}";
    case "{*sdk测试环境域名*}":
      return "{*云挂机测试环境域名*}";
    default:
      return "{*云挂机线上环境域名*}"; 
  }
}

export const activityLink = {
  summary: NODE_ENV ? `${window.location.origin}/h5sdk/activity/summary` : 'http://172.16.20.255:8099/h5sdk/activity/summary',
  flash: NODE_ENV ? `${window.location.origin}/h5sdk/activity/flashPage` : 'http://172.16.20.255:8099/h5sdk/activity/flashPage'
};

// vip推送链接
export const vipPushLink = `${window.location.origin}/h5sdk/apiYellowLogin/vip-customer?vipPush=1`;

// 优惠券弹窗链接
export const voucherLink = `${window.location.origin}/h5sdk/voucher/hint`;

// 企点QQ
export const QI_DIAN_QQ = "{*企点客服链接*}";

// 部分需要拼接域名的地方使用 @@
export const ENV_URL = !NODE_ENV ? DEV_ENV_URL : "https://sdk-api.zhangyuqu.com";

export const h5RouterList = ['/h5sdk/h5', '/yellowlogin', '/h5sdk/hy']

export const boxDownloadUrl = () => {
  const urlCache = localStorage.getItem('boxDownloadUrl');
  return urlCache
}

export const wxBoxDownloadUrl = () => {
  const urlCache = localStorage.getItem('boxDownloadUrl');
  return urlCache
}

export const skinList = ['tg2', 'legend', 'redEnvelope', 'yssl', 'dhcl'];
